function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "text-/-text_bold",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6025,20 C15.1985,20 16.4375,19.706 17.3195,19.118 C18.3485,18.404 18.8735,17.312 18.8735,15.8 C18.8735,14.792 18.6215,13.973 18.1175,13.364 C17.6135,12.755 16.8575,12.356 15.8705,12.167 C16.6265,11.894 17.1935,11.474 17.6135,10.928 C18.0335,10.34 18.2435,9.626 18.2435,8.786 C18.2435,7.631 17.8445,6.728 17.0465,6.056 C16.2065,5.342 15.0725,5.006 13.6025,5.006 L6.7565,5.006 L6.7565,20 L13.6025,20 Z M12.9935,11.369 L9.0455,11.369 L9.0455,6.896 L13.0355,6.896 C14.0435,6.896 14.7995,7.064 15.2615,7.421 C15.7235,7.757 15.9545,8.303 15.9545,9.059 C15.9545,9.857 15.7235,10.445 15.2615,10.823 C14.7995,11.18 14.0435,11.369 12.9935,11.369 Z M13.2875,18.11 L9.0455,18.11 L9.0455,13.238 L13.3505,13.238 C14.4425,13.238 15.2615,13.427 15.7865,13.826 C16.3115,14.225 16.5845,14.876 16.5845,15.758 C16.5845,16.619 16.2275,17.249 15.5555,17.648 C15.0095,17.942 14.2535,18.11 13.2875,18.11 Z",
  id: "B",
  stroke: "#555555",
  fill: "#555555",
  fillRule: "nonzero"
}));

function SvgTextBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "text / text_bold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBold);
export default __webpack_public_path__ + "static/media/text_bold.1409e5c5.svg";
export { ForwardRef as ReactComponent };